import PropTypes from 'prop-types'

import { checkIsExternalUrl } from 'utils'

import { COLOURS } from 'resources'

import { DisabledLink, ExternalLink, InternalLink } from './styles'

const PrimaryLink = ({
  to = '#',
  className = '',
  color = COLOURS.primaryBlue,
  children = null,
  onClick = null,
  rel = 'noopener noreferrer',
  target = '_blank',
  disabled = false,
}) => {
  if (disabled) {
    return <DisabledLink color={color}>{children}</DisabledLink>
  }
  if (typeof to === 'string' && checkIsExternalUrl(to)) {
    return (
      <ExternalLink className={className} href={to} onClick={onClick} target={target} rel={rel} color={color}>
        {children}
      </ExternalLink>
    )
  }
  return (
    <InternalLink to={to} className={className} onClick={onClick} color={color}>
      {children}
    </InternalLink>
  )
}

PrimaryLink.propTypes = {
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  className: PropTypes.string,
  color: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  onClick: PropTypes.func,
  rel: PropTypes.string,
  target: PropTypes.string,
  disabled: PropTypes.bool,
}

export default PrimaryLink
